module.exports = __webpack_public_path__ + "img/s2-2.d3537009.svg";